import { render } from "./AnimatingNumberDev.vue?vue&type=template&id=f3c6f9bc"
import script from "./AnimatingNumberDev.vue?vue&type=script&lang=js"
export * from "./AnimatingNumberDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__